export function formatUSD(n, digits = 2) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (n === 0) return "$0.00";
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000_000) return `$${(n / 1_000_000_000_000).toFixed(2)}T`;
  if (abs >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (abs >= 1000) return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
  if (abs < 1) return `$${n.toFixed(4)}`;
  return `$${n.toFixed(digits)}`;
}

/**
 * Prix dans sa devise de cotation : dollars comme avant ($1,234), autres devises au format français
 * avec leur symbole (ex. « 9 120 ¥ », « 3,45 £ »).
 */
export function formatPrice(n, currency = "USD") {
  const cur = (currency || "USD").toUpperCase();
  if (cur === "USD") return formatUSD(n);
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n);
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: cur,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: abs >= 1000 ? 0 : abs < 1 ? 4 : 2,
    }).format(n);
  } catch {
    return `${n.toLocaleString("fr-FR", { maximumFractionDigits: 2 })} ${cur}`;
  }
}

export function formatPct(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n >= 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
}

export function formatNumber(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return n.toLocaleString();
}
